import { Settings } from "./setting";

export class TableData {
    settings: Settings;
    public setData(data: Settings) {
        this.settings = data;
    }
  
    constructor() {
        this.settings = new Settings ({
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            viewType: 'daysOfMonth',
            dealerShipId: 0,
            dealerGroupId: "5",
            quarter: 4,

        })
    }


}


// WEBPACK FOOTER //
// ./src/app/components/class/table-data.ts